module.exports = __webpack_public_path__ + "static/media/copy.86daa668.svg";